import { StateCreator } from 'zustand';
import {
  AuthorizedUserType,
  IAuthOnboardingSlice,
  InviteStatus,
} from '@Store/slices/authOnboarding/authOnboarding.types.ts';

export const createAuthOnboardingSlice: StateCreator<IAuthOnboardingSlice> = (set, get) => ({
  authOnboardingSlice: {
    customerId: '',
    customerFirstName: '',
    customerLastName: '',
    customerBusinessName: '',
    authorizedUserFullName: '',
    inviteStatus: InviteStatus.ACTIVE,
    authorizedUserType: AuthorizedUserType.ACCOUNTANT,
    consentFormData: null,
  },
  setAuthOnboardingData: (data) => {
    set(() => ({ authOnboardingSlice: data }));
  },
  getAuthUserType: () => get().authOnboardingSlice.authorizedUserType,
  getAuthUserAccessToken: () => get().authOnboardingSlice.accessToken || '',
  setAuthUserAccessToken: (token) =>
    set(() => ({ authOnboardingSlice: { ...get().authOnboardingSlice, accessToken: token } })),
  setConsentFormData: (formData) =>
    set(() => ({
      authOnboardingSlice: { ...get().authOnboardingSlice, consentFormData: formData },
    })),
  getConsentFormData: () => get().authOnboardingSlice.consentFormData || null,
});
